// ScenarioDetailsForm.jsx
import { TextField } from '@mui/material';

export default function ScenarioDetailsForm({ data = {}, onChange }) {

  const handleText = (field) => (e) => {
    onChange?.({ [field]: e.target.value });
  };

  const handleNumber = (field) => (e) => {
    // Keep as string in the input; cast when saving in the parent
    onChange?.({ [field]: e.target.value });
  };

  return (
    <div style={{display:'flex', maxHeight:'60vh', overflowY:'auto'}}>
    <div style={{ display:'flex', flexDirection:'column', width:'50%', maxWidth:'500px', minWidth:'450px', marginLeft:'10px', marginTop:'5px' }}>
      <TextField
        label="Scenario title *"
        type="text"
        value={data.title || ''}
        onChange={handleText('title')}
        style={{ width: '100%', marginBottom:'1rem' }}
        placeholder="A reference only. This will not be visible to the participant."
      />

      <TextField
        label="Scenario description *"
        multiline
        value={data.description || ''}
        onChange={handleText('description')}
        style={{ width: '100%', marginBottom:'1rem' }}
        placeholder="Provide a brief overview of the scenario."
      />

      <TextField
        label="Scenario vignette *"
        multiline
        value={data.vignette || ''}
        onChange={handleText('vignette')}
        style={{ width: '100%', marginBottom:'1rem' }}
        placeholder="Shown to the participant at start."
      />

      <TextField
        label="Patient complaint *"
        value={data.complaint || ''}
        onChange={handleText('complaint')}
        style={{ width: '100%', marginBottom:'1rem'}}
        placeholder="Visible to the participant."
      />

      <TextField
        label="Time (mins)"
        type="number"
        value={data.time ?? ''}  // keep empty string when unset
        onChange={handleNumber('time')}
        style={{ width: '100%' }}
        placeholder="Approximate scenario length in minutes."
      />
    </div>
    </div>
  );
}
